import React, { useEffect, useState } from "react";
// FIX: Removed unused NavLink import.
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { format } from "date-fns";
import RegisterForm from "./RegisterForm-workable";




const EventsDetails = () => {


  useEffect(() => {
    // Check URL hash
    if (window.location.hash) {
      const elementId = window.location.hash.replace("#", "");
      const element = document.getElementById(elementId);

      if (element) {
        // Smooth scroll to the element
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200); // small delay to ensure DOM is ready
      }
    }
  }, []);



  const title = "Event Details";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const formatDate = (date) => {
    if (!date) return "";
    try {
      const parsedDate = typeof date === "string" ? new Date(date) : date;
      return format(parsedDate, "dd MMMM yyyy");
    } catch {
      return date;
    }
  };



  return (
    <>
      <Helmet>
        <title>
          FSA/FCA supervision history &amp; remittance firm expectations | MSB Association
        </title>
        <link
          rel="canonical"
          href="https://msbassociationuk.org/fca-supervision-2009-to-today"
        />
        <meta
          name="description"
          content="Join Mr. James Borley, Director at Complyport and former FCA supervisor, for a free webinar on how MSB supervision has evolved since 2009. Thursday, 20th August 2026, 2:00 PM (UK Time)."
        />
        <meta
          property="og:title"
          content="FSA/FCA supervision history & remittance firm expectations | MSB Association"
        />
        <meta
          property="og:url"
          content="https://msbassociationuk.org/fca-supervision-2009-to-today"
        />
        <meta
          property="og:description"
          content="Join Mr. James Borley for an exclusive webinar on FCA supervision of MSBs since 2009, FCA vs HMRC roles, current priorities, and the future of payment services regulation."
        />
        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="page_header text-center section_decoration overflow-hidden eventbg-image-css">
        <div className="container">
          <motion.h1
            className="page_title text-white"
            initial="hidden"
            animate="visible"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {title.split("").map((letter, index) => (
              <motion.span
                key={index}
                custom={index}
                variants={letterVariants}
                style={{
                  display: "inline-block",
                  marginRight: letter === " " ? "0.3rem" : "0",
                  whiteSpace: "pre",
                }}
              >
                {letter}
              </motion.span>
            ))}
          </motion.h1>
        </div>
      </section>

      <section className="contact_section section_space" style={{ scrollBehavior: "smooth" }}>
        <style>{`
          img.event-details-banner-img {
            border-radius: 20px;
            display: block;
            width: 100%;
            height: auto;
          }

          /* Mobile: keep same gutters as Topic / Date sections; crop empty side artwork only */
          @media (max-width: 767.98px) {
            .event-details-banner-crop {
              width: 100%;
              overflow: hidden;
              line-height: 0;
              border-radius: 12px;
            }

            img.event-details-banner-img {
              width: 128% !important;
              max-width: none !important;
              margin: -1% 0 -1% -14%;
              border-radius: 0;
            }
          }

          @media (max-width: 575.98px) {
            .event-details-banner-crop {
              border-radius: 10px;
            }

            img.event-details-banner-img {
              width: 136% !important;
              max-width: none !important;
              margin: -1.5% 0 -1.5% -18%;
            }
          }
        `}</style>
        <div className="container">
          <div className="item_details_content p-3">
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginTop: "20px",
              }}
            >
              <h3>FREE WEBINAR -</h3>
            </div> */}
            
            <div className="row mb-4 mt-4">
              <div className="col-12 mb-4">
                <div className="event-details-banner-crop">
                  <img
                    src="/assets/images/event-banner/james-webinar-eventsdetails-img.jpg"
                    alt="Free webinar: A history lesson on FSA/FCA supervision since 2009 with Mr. James Borley"
                    className="img-fluid event-details-banner-img"
                  />
                </div>
              </div>
              <div className="col-12 mb-3 mt-2">
                <p
                  className="mb-1"
                  style={{
                    color: "#f7931e",
                    fontSize: "13px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                  }}
                >
                  Topic
                </p>
                <h2
                  className="mb-0"
                  style={{
                    color: "#222",
                    fontSize: "clamp(1.2rem, 2.2vw, 1.65rem)",
                    fontWeight: 700,
                    lineHeight: 1.4,
                    borderBottom: "3px solid #f7931e",
                    paddingBottom: "12px",
                  }}
                >
                  A history lesson on FSA/FCA supervision since 2009 and what
                  the FCA expects from remittance firms today
                </h2>
              </div>
            <div className="row mt-4 mb-5 align-items-stretch">
              <div className="col-lg-4 col-md-4 col-12 d-flex">
                <div className="event-detail-bg mb-1 w-100 align-items-center">
                  <img src="assets/images/event-banner/date.svg" alt="Date" />

                  <div className="text-white">

                    <span className="fw-bolder">Date</span>
                    <h6 className="fw-bold mb-1 text-white lh-base">Thursday, 20th August 2026</h6>

                  </div>

                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12 d-flex">
                <div className="event-detail-bg mb-1 w-100 align-items-center">
                  <img src="assets/images/event-banner/time.svg" alt="Time" />

                  <div className="text-white">

                    <span className="fw-bolder">Time</span>

                    <h5 className="fw-bold mb-1 text-white">2:00 PM (UK Time)</h5>
                  </div>

                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-12 d-flex">
                <div className="event-detail-bg mb-1 w-100 align-items-center">
                  <img src="assets/images/event-banner/speaker.svg" alt="Speaker" />

                  <div className="text-white">
                    <span className="fw-bolder">Speaker</span>

                    <h6 className="fw-bold mb-1 text-white lh-base" style={{ fontSize: "14px" }}>Mr. James Borley, Director for Payment Services</h6>
                  </div>

                </div>
              </div>
            </div>

              <div className="col-12">
                <div className="schedule-date fw-bold fs-5">
                  Description
                </div>
                <div className="schedule-card">
                  <div className="schedule-data mb-2">
                    {/* <p className="mb-2"><strong>Date:</strong> Thursday, 20th August 2026</p>
                    <p className="mb-2"><strong>Time:</strong> 2:00 PM (UK Time)</p>
                    <p className="mb-2"><strong>Topic:</strong> A history lesson on FSA/FCA supervision since 2009 and what the FCA expects from remittance firms today</p>
                    <p className="mb-4"><strong>Speaker:</strong> Mr. James Borley, Director, Complyport and Ex-FCA</p> */}

                    {/* <h5><strong>A history lesson on FSA/FCA supervision since 2009 and what the FCA expects from remittance firms today</strong></h5> */}
                    <p>Join Mr. James Borley, Director for Payment Services at Complyport, for an exclusive webinar exploring how the supervision of Money Service Businesses (MSBs) has evolved since the introduction of payment services regulation in 2009.</p>
                    <p>Drawing on his experience as both a regulator and compliance consultant, James will share practical insights into the changing role of the FCA, the relationship between the FCA and HMRC, current regulatory priorities, and the future of payment services regulation.</p>
                    <p>Whether you are a business owner, compliance professional, or senior manager, this session will help you better understand today&apos;s regulatory expectations and prepare your remittance business for future developments.</p>

                    <h5><strong>What You&apos;ll Learn</strong></h5>
                    <ul>
                      <li>From FCA Supervision to Market Intervention – How the FCA&apos;s approach to supervising Money Service Businesses has evolved since 2009.</li>
                      <li>FCA vs HMRC – Understanding the different roles and responsibilities of each regulator and how they impact MSBs.</li>
                      <li>The Big Issues – What the FCA is focusing on today and what remittance firms need to do to meet regulatory expectations.</li>
                      <li>Future Developments – An overview of HM Treasury&apos;s consultation on proposed changes to the Payment Services Regulations and the potential impact on the industry.</li>
                      <li>Practical insights from an experienced former FCA supervisor and regulatory consultant.</li>
                      <li>Key actions businesses can take to strengthen governance, compliance, and regulatory readiness.</li>
                    </ul>
                    <br />
                    <p>This session is designed to help you understand how FCA supervision has evolved, navigate today&apos;s regulatory expectations, and prepare your remittance business for the future of payment services regulation.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <RegisterForm /> */}
          <RegisterForm />
        </div>
      </section>
    </>
  );
};

export default EventsDetails;